import classNames from 'classnames';
import { ReactNode, useState, type JSX } from 'react';

import { LayoutContainer } from 'components/layout-container';

import styles from './styles.module.scss';

export type MarqueeProps = {
  className?: string;
  itemClassName?: string;
  children: ReactNode[];
};

export type MarqueeContentProps = MarqueeProps & {
  ariaHidden?: boolean;
  paused?: boolean;
};

function MarqueeContent({
  itemClassName,
  children,
  ariaHidden = false,
  paused = false,
}: MarqueeContentProps): JSX.Element {
  return (
    <ul
      className={classNames(styles.marqueeContent, { [styles.paused]: paused })}
      aria-hidden={ariaHidden}
    >
      {children.map((item, i) => (
        <li className={itemClassName} key={i}>
          {item}
        </li>
      ))}
    </ul>
  );
}

export function Marquee({ className, itemClassName, children }: MarqueeProps) {
  const [paused, setPaused] = useState(false);

  return (
    <div
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <LayoutContainer
        size="large"
        className={classNames(styles.marquee, className)}
      >
        <MarqueeContent itemClassName={itemClassName} paused={paused}>
          {children}
        </MarqueeContent>
        <MarqueeContent
          itemClassName={itemClassName}
          ariaHidden
          paused={paused}
        >
          {children}
        </MarqueeContent>
      </LayoutContainer>
    </div>
  );
}
